<template>
  <div class="simple-input-layout">
    <span v-if="loading" class="simple-input-data">
      <content-spinner />
    </span>
    <span v-else-if="spec.editable" class="simple-input-data">
      <div class="data-layout">
        <span v-if="saving" class="status-saving"/>
        <span v-else-if="hasErrors" class="status-error"/>
        <span v-else class="status-saved"/>
        <slot name="editable"/>
      </div>
    </span>
    <span v-else class="simple-input-data">
      <div class="data-layout readonly">
        <span class="status-readonly"/>
        <div class="ml2"><slot name="readonly"/></div>
      </div>
    </span>
    <div class="simple-input-error">
      <span style="color: red" v-for="e in errors" v-bind:key="e" class="db mv1">
        {{ e }}
      </span>
    </div>
  </div>
</template>

<script>
import ContentSpinner from '@/components/common/ContentSpinner.vue'

export default {
  props: ['spec', 'errors', 'loading', 'saving'],
  components: {
    ContentSpinner
  },
  computed: {
    hasErrors () {
      return Array.isArray(this.errors) && this.errors.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.simple-input-layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  grid-template-areas:
    "data"
    "error";
}
.simple-input-data {
  grid-area: data;
  height: 100%;
}
.horizontal-input-error {
  grid-area: error;
  font-size: .875rem;
}
.status {
  display: block;
  height: 100%;
  width: 100%;
}
.status-saved {
  @extend .status;
  background-color: #9EEBCF;
}
.status-saving {
  @extend .status;
  background-color: #FFB700;
}
.status-error {
  @extend .status;
  background-color: #ff4136;
}
.status-readonly {
  @extend .status;
  background-color: #F0F4F8;
}
.readonly {
  min-height: 40px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border-style: solid;
  border-width: 1px;
  border-color: #F0F4F8;
}
.data-layout {
  display: grid;
  grid-template-columns: 3px 1fr;
  grid-template-rows: auto;
  align-items: center;
  min-height: 40px;
}
</style>
